
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[categorySlug]/[courseSlug]",
      function () {
        return require("private-next-pages/[categorySlug]/[courseSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[categorySlug]/[courseSlug]"])
      });
    }
  